/* eslint-disable no-param-reassign */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import speedometerSize from '../speedometers/Speedometer_Size_NoLoop_04_Lottie.json';

const SpeedometerSize = (props) => {

    return (
        <Lottie animationData={JSON.parse(JSON.stringify(speedometerSize))} {...props}/>
    );
}

export default SpeedometerSize;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/speedometers/speedometerSize.jsx